import { memo } from 'react';

import CheckmarkIconSVG from '@/assets/checkmark-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ICheckmarkIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={CheckmarkIconSVG} {...props} />;

export const CheckmarkIcon = memo(ICheckmarkIcon) as typeof ICheckmarkIcon;
